import { useLocation } from "react-router";
import { Table } from "../../features/Table";
import { type EnumTranslation, enum_translation_columns } from "./columns";
import { FilterEnumTranslations } from "./filter";

const client = "etl-quantilia";
const table_name = "enum_translations";

export const EnumTranslationsTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<EnumTranslation, EnumTranslation>
      label="Enum Translations"
      client={client}
      table_name={table_name}
      columns={enum_translation_columns}
      filter={<FilterEnumTranslations />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
